<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Empresas</h5>
                <hr>

				<Toolbar class="p-mb-4">
					<template slot="left">						
						<Button type="button" icon="pi pi-plus" label="Nova" class="p-mr-2" @click="novo" v-if="permissaoNovo"/>												
					</template>
				</Toolbar>

				<DataTable :value="empresas"   :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">				
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>	
					<Column field="id" header="Id" sortable></Column>			
					<Column field="nome" header="Nome" sortable></Column>
					<Column field="cnpj" header="CNPJ/CPF" sortable>
						<template #body="slotProps">
							<label v-if="slotProps.data.tipoNumeroDocumento == 'cnpj'">
								{{ slotProps.data.cnpj | maskCNPJ }}
							</label>
							<label v-else>
								{{ slotProps.data.cnpj | maskCPF }}
							</label>							
						</template>
					</Column>				
					<Column field="seguimento" header="Seguimento" sortable></Column>
					<Column field="dataCadastro" header="Cadastro" sortable></Column>
					<Column field="idRevendedor" header="Revendedor" sortable></Column>	
					<Column field="status" header="Status" sortable>
						<template #body="slotProps">                                    
							<div>   							                                     
								<span class="p-badge p-badge-lg p-badge-danger" title="Cliente Bloqueado" v-if="slotProps.data.status == 2" >
									<i style="color:#F9B720" class="pi pi-lock" ></i>                                       
								</span>
								<span class="p-badge p-badge-lg p-badge-secondary" title="Cliente Inativo" v-else-if="slotProps.data.status == 0" >
									<i class="pi pi-power-off" ></i>                                       
								</span>
								<span class="p-badge p-badge-lg p-badge-success" title="Cliente Ativo" v-else>                                          
									<i class="pi pi-lock-open"></i>
								</span>                                        
							</div>
						</template>
					</Column>					
					<Column  header="Editar">
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>							
						</template>
					</Column>
				</DataTable>						

			</div>
		</div>
	</div>
</template>

<script>
import EmpresaService from '@/service/EmpresaService';
import Cnpj from '@/model/Cnpj';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
	empresaService: null,
	data() {
		return {
			permissaoNovo: false,
			permissaoEditar: false,			
			exibirDialogCadastro: false,		
			enviandoForm: false,	
			cnpj: new Cnpj(),	
			cnpjs: [],		
			diasInicio: [],
			diasFinal: [],
			empresa: {},
            empresas: [],
			filtro: {}
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),	
		listar(){
			let requisicao = {                   
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
			this.empresaService.listar(requisicao)
				.then(resp => {			
					this.empresas = resp.data;					
                })
                .catch(erro => {exibirMensagem(this, erro)});

		},
		novo() {
			this.$router.push('/cadastro/clientes/ikponto/novo');
		},
		editar(empresa) {
			this.$router.push('/cadastro/clientes/ikponto/'+empresa.id+'/editar');
		},
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(99999);
			this.permissaoEditar = permissoes.includes(99999);				
		}
	},	
	created() {
		this.empresaService = new EmpresaService();		
	},
	mounted() {	
		this.validarPermissoes();	
		this.listar();		
	}
}
</script>

<style scoped>
</style>